import { render, staticRenderFns } from "./customers-modal-list.vue?vue&type=template&id=3f558608&scoped=true&"
import script from "./customers-modal-list.vue?vue&type=script&lang=js&"
export * from "./customers-modal-list.vue?vue&type=script&lang=js&"
import style0 from "./customers-modal-list.vue?vue&type=style&index=0&id=3f558608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f558608",
  null
  
)

export default component.exports